// Section title mapping
export const SECTION_TITLES = {
  'idea_summary': 'Idea Overview',
  'technical_requirements': 'Technical Requirements',
  'market_analysis': 'Market Analysis',
  'performance_applications': 'Performance & Applications',
  'research_papers': 'Research Foundation',
  'executive_summary': 'Executive Summary',
  'regulatory_compliance': 'Regulatory Compliance',
  'financial_analysis': 'Financial Analysis',
  'risk_assessment': 'Risk Assessment',
  'references': 'Research Resources'
};

// Section icons mapping
export const SECTION_ICONS = {
  'idea_summary': '📝',
  'technical_requirements': '🛠️',
  'market_analysis': '📈',
  'performance_applications': '🎯',
  'research_papers': '📚',
  'executive_summary': '📋',
  'regulatory_compliance': '📋',
  'financial_analysis': '💰',
  'risk_assessment': '⚠️',
  'references': '📚'
};

/**
 * Format section title with proper capitalization
 */
export const formatSectionTitle = (sectionType) => {
  if (!sectionType) return 'Untitled Section';
  
  return SECTION_TITLES[sectionType] || 
    String(sectionType)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());
};

/**
 * Get icon for section type
 */
export const getSectionIcon = (sectionType) => {
  return SECTION_ICONS[sectionType] || '📄';
};

/**
 * Calculate confidence level statistics
 */
export const getConfidenceStats = (confidenceLevels) => {
  const confidence = confidenceLevels || { High: 0, Medium: 0, Low: 0 };
  const total = confidence.High + confidence.Medium + confidence.Low;

  if (total === 0) return null;

  return {
    high: {
      count: confidence.High,
      percentage: Math.round((confidence.High / total) * 100)
    },
    medium: {
      count: confidence.Medium,
      percentage: Math.round((confidence.Medium / total) * 100)
    },
    low: {
      count: confidence.Low,
      percentage: Math.round((confidence.Low / total) * 100)
    },
    total,
    overall: confidence.High / total > 0.6 ? 'High' : 
             confidence.High / total > 0.3 ? 'Medium' : 'Low'
  };
};
